__turbopack_context__.v({
  "boxContentElement": "JEYBpa_boxContentElement",
  "boxContentElementWrapper": "JEYBpa_boxContentElementWrapper",
  "contents": "JEYBpa_contents",
  "heading": "JEYBpa_heading",
  "root": "JEYBpa_root",
});
